import { gql } from '@apollo/client';
import { QUESTION_COMMENT_FIELDS } from './question';

export const JOB_USER_FRAGMENT = gql`
  fragment JobUser on User {
    id
    username
    firstName
    lastName
    accessLevel
  }
`;

export const JOB_REMARK_FRAGMENT = gql`
  ${JOB_USER_FRAGMENT}
  fragment JobRemark on JobRemark {
    id
    createdAt
    jobId
    status
    remark
    recordId
    resolvedAt
    createdByUser {
      ...JobUser
    }
    resolvedByUser {
      ...JobUser
    }
  }
`;

export const JOB_ASSET_FRAGMENT = gql`
  fragment JobAsset on JobAsset {
    id
    jobId
    recordId
    pictureId
    index
    type
    choiceLabel
    createdAt
    picture {
      id
      updatedAt
      name
      sensitive
      caption
      path
      path256
      path512
      overlayPath
      overlayPath256
      overlayPath512
      thumbhash
      index
    }
  }
`;

export const JOB_RECORD_METRICS_SUMMARY_FRAGMENT = gql`
  fragment JobRecordMetricsSummary on JobRecordMetricsSummary {
    id
    total
    correct
    incorrect
    percentage
  }
`;


export const JOB_RECORD_STATISTICS_FRAGMENT = gql`
  ${JOB_RECORD_METRICS_SUMMARY_FRAGMENT}
  ${QUESTION_COMMENT_FIELDS}
  fragment JobRecordStatistics on JobRecord {
    # metricsSummary(filter: { attemptType: 1 }) {
    #   ...JobRecordMetricsSummary
    # }
    question {
      __typename
      id
      typeId
      likes
      dislikes
      comments {
        ...QuestionCommentFields
      }
      choices {
        id
        name
        label
        votes
        answer
        questionId
      }
    }
  }
`;

export const JOB_RECORD_QUESTION_FRAGMENT = gql`
  fragment JobRecordQuestion on JobRecordQuestion {
    question
    stem
    conceptId
    typeId
    answer
    entitlementIds
    themeIds
    subTypeId
    presentationIds
    conditionIds
    conditionAreaIds
    presentationAreaIds
    ukmlaTopicId
    choices {
      label
      name
      explanation
      answer
    }
    cases {
      label
      case
      explanation
    }
    prescriptions {
      doseId
      doseVisible
      drugId
      drugVisible
      routeId
      routeVisible
      frequencyId
      frequencyVisible
      durationId
      durationVisible
      index
      questionId
    }
    irtParameters {
      discrimination
      difficulty
      guessing
    }
    learningPoint
    explanation
  }
`;

export const JOB_RECORD_CHAPTER_FRAGMENT = gql`
  fragment JobRecordChapter on JobRecordChapter {
    topic
    concept
    explanation
    summary
    entitlementIds
  }
`;

export const JOB_RECORD_STATION_FRAGMENT = gql`
  fragment JobRecordStation on JobRecordStation {
    name
    hiddenName
    explanation
    actorBrief
    examinerBrief
    candidateBrief
    difficulty
    osceTypeId
    topicIds
    entitlementIds
    osceTypeId
    marks {
      header
      index
      name
    }
  }
`;

export const JOB_RECORD_MOCK_TEST_FRAGMENT = gql`
  fragment JobRecordMockTest on JobRecordMockTest {
    question
    stem
    conceptId
    typeId
    answer
    themeIds
    subTypeId
    choices {
      label
      name
      explanation
      answer
    }
    cases {
      label
      case
      explanation
    }
    prescriptions {
      doseId
      doseVisible
      drugId
      drugVisible
      routeId
      routeVisible
      frequencyId
      frequencyVisible
      durationId
      durationVisible
      index
      questionId
    }
    irtParameters {
      discrimination
      difficulty
      guessing
    }
    learningPoint
    explanation
  }
`;

export const JOB_RECORD_STATUS_FRAGMENT = gql`
  fragment JobRecordStatus on JobRecord {
    status
  }
`;

export const JOB_RECORD_FRAGMENT = gql`
  ${JOB_REMARK_FRAGMENT}
  ${JOB_RECORD_STATUS_FRAGMENT}
  ${JOB_RECORD_QUESTION_FRAGMENT}
  ${JOB_RECORD_CHAPTER_FRAGMENT}
  ${JOB_RECORD_STATION_FRAGMENT}
  ${JOB_RECORD_MOCK_TEST_FRAGMENT}
  ${JOB_RECORD_STATISTICS_FRAGMENT}
  ${JOB_ASSET_FRAGMENT}
  fragment JobRecord on JobRecord {
    id
    jobId
    index
    referenceId
    referenceCount
    aiGenerated
    data {
      ... on JobRecordQuestion {
        ...JobRecordQuestion
      }
      ... on JobRecordChapter {
        ...JobRecordChapter
      }
      ... on JobRecordStation {
        ...JobRecordStation
      }
      ... on JobRecordMockTest {
        ...JobRecordMockTest
      }
    }
    remarks {
      ...JobRemark
    }
    assets {
      ...JobAsset
    }
    createdByUser {
      ...JobUser
    }
    questionId
    stationId
    chapterId
    createdAt
    updatedAt
    publishedAt
    ...JobRecordStatus
    ...JobRecordStatistics
  }
`;
